import React, { useContext } from "react";
import { SavingContext } from "../hooks/UseSaving";
import { Price } from "../components/zauneditor/Price";
import { EditInZaunButton } from "./MHelper";

export function FooterButtons() {
  const { save, active } = useContext(SavingContext);

  return (
    <nav aria-label={I18N("aria::Aktionen und Navigation")} className="footer-buttons-nav">
      {APP.optionMenu && !APP.optionMenu?.isLastItem() && (
        <Price onlyBestellliste={true} highlightElements={false} />
      )}

      {APP.optionMenu && APP.optionMenu?.isLastItem() && APP.configuration.Code && (
        <EditInZaunButton />
      )}

      <button
        key={I18N("Speichern")}
        aria-label={I18N("aria::Konfiguration speichern")}
        onClick={() => save()}
        className={
          (APP.optionMenu?.isLastItem() ? "nextStepButton" : "") +
          "saveButton button clickable fading"
        }
      >
        {I18N("Speichern")}
      </button>

      {APP.optionMenu && !APP.optionMenu?.isLastItem() && (
        <button
          id="weiterButton"
          aria-label={I18N("aria::Zum nächsten Schritt")}
          key={I18N("Weiter")}
          onClick={APP.optionMenu.nextItem}
          className={"nextStepButton button clickable fading"}
        >
          {I18N("Weiter")}
        </button>
      )}
    </nav>
  );
}
